/**
 * Utility helpers for the OrderDetected / "Create Order" section gating in
 * EmailViewModal.
 *
 * Extracted for testability — getting this gate wrong strands CSRs: hiding
 * Create Order on an email whose no-draft banner cannot point at an actual
 * existing order leaves no draft, no order to edit, and no way to enter one
 * (Roblyn, Siegel Bros PO 5042557 — the agent read the PO form's printed
 * "Rev 1" marker as a revision, no order matched, and the create path was
 * suppressed anyway).
 */
import type { PortalNoDraftReason } from '../types/portal';

/**
 * Whether the OrderDetected / "Create Order" section should be suppressed
 * because the no-draft banner already links the order this email is about.
 *
 * Suppress ONLY when the reason is a dup/revision type AND it actually
 * carries an existing order — creating a second order would then be a
 * duplicate. When the lookup found nothing, the CSR must keep the ability
 * to create the order manually.
 */
export function shouldSuppressCreateOrder(
  reason: PortalNoDraftReason | null | undefined,
): boolean {
  if (!reason) return false;
  if (
    reason.type !== 'thread_dup' &&
    reason.type !== 'order_revision' &&
    reason.type !== 'agent_marked_revision'
  ) {
    return false;
  }
  return Boolean(reason.existing_order);
}
